export const CHART_THRESHOLD_FILL_CANVAS_ATTR = 'data-threshold-fill-canvas';
